import API from '../utils/request'

export function getBdYxtClueRecordDtos (data) {
  return API.get('/data/marktingexpert/getBdYxtClueRecordDtos', data)
}

export function getBdYxtMessageDto () {
  return API.get('/data/marktingexpert/getBdYxtMessageDto')
}

export function updateBdYxtClueRecordStatus (data) {
  return API.post('/data/marktingexpert/updateBdYxtClueRecordStatus', data)
}

export function downLoadClueExcel (data) {
  return API.bolbPost('/data/marktingexpert/downLoadClueExcel', data, {
    responseType: 'blob'
  })
}
